import cs from 'classnames'
import { Box, Divider } from 'components/Material/index'

type SidebarFooterProps = {
  children: React.ReactNode
  className?: string
  divider?: boolean
}

export const SidebarFooter = ({ children, className, divider = true }: SidebarFooterProps) => {
  return (
    <Box className={cs('text-center flex flex-col items-center gap-5 pb-6  ', className)}>
      {divider && (
        <Box>
          <Divider
            variant="fullWidth"
            style={{
              position: 'absolute',
              left: 0,
              right: 0,
              zIndex: 200
            }}
          />
        </Box>
      )}
      {children}
    </Box>
  )
}
